// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__3ATBq","HeaderContent":"Header_HeaderContent__3ezOl","LogoDiv":"Header_LogoDiv__1n_kd","Shape":"Header_Shape__3oOQp"};